// extracted by mini-css-extract-plugin
module.exports = {"cursor":"BookingTimeInfo_cursor__2weHm","root":"BookingTimeInfo_root__1Fw5P","bookingInfo":"BookingTimeInfo_bookingInfo__1UuoI","dateSection":"BookingTimeInfo_dateSection__2j9Xe"};